export default "__VITE_ASSET__CxSq7YK3__"